<template>
  <div id="app">
    <router-view/>
  </div>


</template>

<script>
export default {
  name: 'App'

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
html,body {
  margin: 0px;
  padding: 0PX;

  width: auto;
  background: #d8d8d8;
  position: relative;
}

</style>





// WEBPACK FOOTER //
// src/App.vue